module.exports = __webpack_public_path__ + "static/img/title.f12aca25.png";